module.exports = __webpack_public_path__ + "img/Groupe 78.86b93b83.svg";